import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from './mixpanel.js'

export default function useTrackPageView() {
  const location = useLocation()

  useEffect(() => {
    trackPageView(location.pathname, { search: location.search })
  }, [location.pathname, location.search])
}
